import { MarketerDashboard } from '../components/dashboards/MarketerDashboard';
import { RepDashboard } from '../components/dashboards/RepDashboard';
import { AdminDashboard } from '../components/dashboards/AdminDashboard';
import { SalesManagerDashboard } from '../components/dashboards/SalesManagerDashboard';

/**
 * Dashboard Page - Routes to role-specific dashboard
 */
export function DashboardPage({ currentUser, restaurants, users, userCommissions, allCommissions }) {
  // Render based on role
  if (currentUser.role === 'marketer') {
    return (
      <MarketerDashboard
        currentUser={currentUser}
        restaurants={restaurants}
        userCommissions={userCommissions}
      />
    );
  }
  
  if (currentUser.role === 'rep') {
    return (
      <RepDashboard
        currentUser={currentUser}
        restaurants={restaurants}
        userCommissions={userCommissions}
      />
    );
  }
  
  if (currentUser.role === 'admin') {
    return (
      <AdminDashboard
        currentUser={currentUser}
        restaurants={restaurants}
        users={users}
        userCommissions={userCommissions}
        allCommissions={allCommissions}
      />
    );
  }
  
  if (currentUser.role === 'sales_manager') {
    return (
      <SalesManagerDashboard
        currentUser={currentUser}
        restaurants={restaurants}
        users={users}
      />
    );
  }

  // Fallback for other roles
  return (
    <div style={{ padding: 32, textAlign: 'center', color: '#000000' }}>
      <p style={{ fontSize: 48, marginBottom: 16 }}>📊</p>
      <p style={{ fontSize: 18, fontWeight: 700, color: '#000000' }}>
        لوحة التحكم قيد التطوير
      </p>
      <p style={{ fontSize: 14, marginTop: 8 }}>
        سيتم إضافة لوحة التحكم قريباً لهذا الدور
      </p>
    </div>
  );
}
